module.exports = __webpack_public_path__ + "static/media/verified.b5cf15b7.svg";